import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
   providedIn: 'root'
})
export class ProviderDataService {

   constructor(private httpClient: HttpClient, private configService: ConfigService) {
   }

   public getList(clientId) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Client/GetProvidersForClient?id=${clientId}`;
      return this.httpClient.get(url);
   }

   public searchProviders(firstName, lastName) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Provider/SearchProviders?firstName=${firstName}&lastName=${lastName}`;
      return this.httpClient.get(url);
   }

   public getByNPI(NPI) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Provider/GetProviderByNPI?NPI=${NPI}`;
      return this.httpClient.get(url);
   }

   public getProvider(id) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Provider/GetProvider?id=${id}`;
      return this.httpClient.get(url);
   }

   public save(client) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Provider`;
      return this.httpClient.post(url, client);
   }

   public searchMedTek21ProvidersByName(firstName, lastName) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Provider/GetMedTek21ProviderByName?firstName=${firstName}&lastName=${lastName}`;
      return this.httpClient.get(url);
   }

   public searchMedTek21ProviderByNPI(NPI) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Provider/GetMedTek21ProviderByNPI?NPI=${NPI}`;
      return this.httpClient.get(url);
   }
}
